<script>
  import LayoutMember from '@layout/Member'
  import List from './components/List'

  export default {
    page() {
      return {
        title: `上課卷`,
      }
    },
    components: {
      LayoutMember,
      List,
    },
    data() {
      return {
        coupon: '',
        couponList: [],
        couponPagination: {},
      }
    },
    created() {
      this.tryToFetchMemberCouponList();
    },
    methods: {
      onChangePagination(page) {
        this.tryToFetchMemberCouponList({
          storeParams: {
            page
          }
        })
      },
      tryToFetchMemberCouponList({ storeParams } = {}) {
        this.$store.dispatch('coupon/fetchCouponList', {
          page: this.$route.query.page,
          ...storeParams
        })
          .then((response) => {
            this.couponList = response.items;
            this.couponPagination = response.pagination;
          })
      },
    },
  }
</script>
<template>
  <LayoutMember>
    <template v-slot:banner>
      <BaseBanner 
        title="上課卷" 
        :image="require('@assets/images/member/banner.png')"
        custom-class="isStyleWhite"
        class="isHasNoFilter"
      />
    </template>
    <div :class="$style.memberCoupon">
      <div class="text-2xl font-medium mb-3 d-md-block d-none">
        我的上課卷
      </div>
      <!-- <el-input
        ref="coupon"
        v-model="coupon"
        placeholder="請輸入新增上課券代碼"
        inputmode="text"
        class="isStyleSearch isCoupon"
      >
      <BaseButton 
        slot="append" 
        class="isStylePrimary isCouponBtn"
        :disabled="!coupon"
        @click="tryToSaveCoupon"
      >
        儲存上課卷
      </BaseButton>
      </el-input> -->
      <div class="memberCoupon__list">
        <div v-for="(couponItem, index) in couponList"
            :key="index"
            class="memberCoupon__item"
        >
          <List
            :item="couponItem"
          />
        </div>
      </div>
      <BasePagination2
        :pagination="couponPagination"
        @change="onChangePagination"
      />
    </div>
  </LayoutMember>
</template>
<style lang="scss" module>
  .memberCoupon {
    @include max-md {
      min-height: calc((var(--vh, 1vh) * 100) - 163px );
    }
    :global {
      .memberCoupon {
        &__list {
          padding-top: 3.2rem;
          @include max-md {
            padding-top: 0;
            min-height: calc((var(--vh, 1vh) * 100) - 163px );
          }
        }

        &__item {
          padding: 2rem 1.3rem;
          background-color: #FFF;
          @include max-md {
            padding: $container-gap;
          }
          &:not(:last-child) {
            margin-bottom: 2rem;
            @include max-md {
              margin-bottom: 1.25rem;
            }
          }

        }
      }

      .isCouponBtn {
        @include max-sm {
          padding: 1rem 1.6rem;
        }
      }
    }
  }
</style>
